import {
  REFERRAL_API_KEY,
  REFERRAL_API_URL,
  REFERRAL_HMAC_SECRET,
} from 'utils/constants/EndpointUrls'

const buildAuthHeader = async (): Promise<string> => {
  const timestamp = String(Math.floor(Date.now() / 1000))
  const encoder = new TextEncoder()
  const key = await crypto.subtle.importKey(
    'raw',
    encoder.encode(REFERRAL_HMAC_SECRET),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  )
  const sig = await crypto.subtle.sign('HMAC', key, encoder.encode(timestamp))
  const hex = Array.from(new Uint8Array(sig))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
  return `${timestamp}.${hex}`
}

export const triggerReferralEvent = async (
  boulevardId: string,
  offerCode: string
): Promise<void> => {
  const authHeader = await buildAuthHeader()
  await fetch(REFERRAL_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': REFERRAL_API_KEY,
      Authorization: authHeader,
    },
    body: JSON.stringify({
      eventType: 'appointment_booked',
      data: {
        boulevard_client_id: boulevardId,
        offer_code: offerCode,
      },
    }),
  })
}
